import * as React from 'react';
import { Wrapper as PageWrapper } from './Wrapper';

export const Page = ({ children }: { children: React.ReactNode }) => {
    return <PageWrapper>
        {children}
    </PageWrapper>
};